module.exports = __webpack_public_path__ + "img/yao_bg.13c0419a.png";